const isActiveArea = (startPosition, endPosition) => {
  if (window.scrollY >= startPosition && window.scrollY < endPosition) {
    return true;
  }
  if (window.scrollY > endPosition || window.scrollY < startPosition) {
    return;
  }
};

const rgbToArray = (rgbString) => {
  let rgbArray = rgbString
    .substring(4, rgbString.length - 1)
    .replace(/ /g, '')
    .split(',');
  return rgbArray;
};

let lastScroll = 0;
const scrollDirection = () => {
  let scrollDirection = '';
  let currentScroll = window.scrollY;
  if (currentScroll > lastScroll) {
    scrollDirection = 'down';
  } else if (currentScroll < lastScroll) {
    scrollDirection = 'up';
  }
  lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  return scrollDirection;
};

const rangeCounter = (item, from, to, increment, speedInMs) => {
  let numDifference = (to - from) / increment;
  let timePerNum = speedInMs / numDifference;
  let counter = from;
  let strLen = 0;
  let counterSpan = item.querySelector('span');
  let counterSpanWidth = counterSpan.clientWidth;
  counterSpan.classList.remove('invisible');
  const counterInterval = setInterval(() => {
    switch (strLen) {
      case 1:
        counter = counter + randomIntFromInterval(1, 2);
        break;
      case 2:
        counter = counter + randomIntFromInterval(5, 20);
        break;
      case 3:
        counter = counter + randomIntFromInterval(50, 90);
        break;
      case 4:
        counter = counter + randomIntFromInterval(100, 400);
        break;
      case 5:
        counter = counter + randomIntFromInterval(1000, 4000);
        break;
      case 6:
        counter = counter + randomIntFromInterval(10000, 40000);
        break;
      case 7:
        counter = counter + randomIntFromInterval(100000, 400000);
        break;
      default:
        counter = counter + increment;
    }
    let counterLen = counter.toString().length;
    if (strLen != counterLen) {
      let width = counterLen * counterSpanWidth;
      counterSpan.style.width = width + 'px';
      strLen = counterLen;
    }
    counterSpan.innerHTML = counter;
    if (counter >= to) {
      clearInterval(counterInterval);
      counterSpan.innerHTML = to;
    }
  }, timePerNum);
};

const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

const getRandomFloat = (min, max) => {
  return Math.random() * (max - min) + min;
};

const digitShuffle = (item, finalNum, speedMs, durationMs) => {
  const counterInterval = setInterval(() => {
    if (durationMs > 0) {
      durationMs -= speedMs;
      item.innerHTML = randomIntFromInterval(1, 9);
    } else {
      clearInterval(counterInterval);
      item.innerHTML = finalNum;
    }
  }, speedMs);
};
